import React from 'react';

export const ImagePlaceholder = () => (
  <path
    transform="matrix(1.1020408,0,0,1,-11.0204,39.95)"
    d="M 881.1,132.5 H 118.9 C 59,132.5 10,181.5 10,241.4 v 517.3 c 0,59.9 49,108.9 108.9,108.9 H 881.1 C 941,867.6 990,818.6 990,758.7 V 241.4 C 990,181.5 941,132.5 881.1,132.5 Z m 68.1,614.8 c 0,54.9 -24.5,79.4 -79.4,79.4 H 130.3 c -54.9,0 -79.4,-24.5 -79.4,-79.4 V 252.7 c 0,-54.9 24.5,-79.4 79.4,-79.4 h 739.5 c 54.9,0 79.4,24.5 79.4,79.4 z M 316.3,418.3 418.3,500 683.7,275.4 887.9,459.2 V 765.5 H 112.1 V 581.7 Z M 193.8,234.6 c -45.1,0 -81.7,36.6 -81.7,81.7 0,45.1 36.6,81.7 81.7,81.7 45.1,0 81.7,-36.6 81.7,-81.7 0,-45.1 -36.6,-81.7 -81.7,-81.7 z"
    fill="#637181"
  />
);
